<template>
  <v-container grid-list-md>
    <v-layout row>
      <v-flex sm12 md6>
        <h3>開始ページ</h3>
        <vue-editor v-model="startPage.content"></vue-editor>
      </v-flex>
      <v-flex sm12 md6>
        <h3>終了ページ</h3>
        <vue-editor v-model="endPage.content"></vue-editor>
      </v-flex>
    </v-layout>
    <v-layout row justify-end>
      <v-btn @click="updateQuestions">保存</v-btn>
    </v-layout>
    <h2>プレビュー</h2>
    <v-layout row>
      <v-flex sm12 md6>
        <h3>開始ページ</h3>
        <html-with-fields-inserted :content="startPage.content"  :insert-fields="insertFileds" class="border"/>
      </v-flex>
      <v-flex sm12 md6>
        <h3>終了ページ</h3>
        <html-with-fields-inserted :content="endPage.content"  :insert-fields="insertFileds"  class="border"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { VueEditor } from "vue2-editor";
import HtmlWithFieldsInserted from "@/components/common/htmlWithFieldsInserted.vue"
export default {
  components: { VueEditor, HtmlWithFieldsInserted },
  props: {
    startPage: {},
    endPage: {},
    insertFileds:{
      type:Array,
      default:""
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    updateQuestions() {
      this.$emit("updateQuestions");
    }
  }
};
</script>
<style lang="scss" scoped>
  .border{
    border: 1px solid gray;
  }
</style>
